import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `${ctx.brand} hjem for anonym chat`,
    languageButtonLabel: `Språk`,
    languageModalTitle: `Velg et språk`,
    languageModalCloseLabel: `Lukk språkmenyen`,
  },
  languageOptions: {
    'en-US': {
      label: `Engelsk (USA)`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `Engelsk (Kenya)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `Engelsk (Nigeria)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `Engelsk (Singapore)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `Portugisisk (Portugal)`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `Portugisisk (Brasil)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `Tysk (Tyskland)`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `Tysk (Østerrike)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `Tysk (Sveits)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `Spansk (Spania)`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `Fransk (Frankrike)`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `Italiensk (Italia)`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `Nederlandsk (Nederland)`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `Polsk (Polen)`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `Svensk (Sverige)`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `Dansk (Danmark)`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `Finsk (Finland)`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `Norsk (Norge)`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `Islandsk (Island)`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `Japansk (Japan)`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `Koreansk (Sør-Korea)`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `Kinesisk (Kina)`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `Kantonesisk (Hongkong SAR Kina)`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `Vietnamesisk (Vietnam)`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `Thai (Thailand)`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `Indonesisk (Indonesia)`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `Swahili (Kenya)`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `Hindi (India)`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `Bengali (Bangladesh)`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `Marathi (India)`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `Telugu (India)`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `Persisk (Iran)`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `Urdu (Pakistan)`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `Panjabi (Pakistan)`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `Nigeriansk pidginspråk (Nigeria)`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `Russisk (Russland)`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `Arabisk (Saudi-Arabia)`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `Arabisk (De forente arabiske emirater)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `Arabisk (Qatar)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `Marokkansk-arabisk (Marokko)`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `Tyrkisk (Tyrkia)`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `Velg et språk`,
    closeLabel: `Lukk språkmenyen`,
  },
  languageHint: (ctx) => `Hopp mellom ${ctx.localesCount}+ språk uten å opprette konto.`,
  readPagePrompt: ({languageLabel}) => `Les denne siden på ${languageLabel}.`,
};
